import {
  AppstoreOutlined,
  BellOutlined,
  GiftOutlined,
  UserOutlined,
} from '@ant-design/icons';
import type { MobileTabKey } from '../MobileApp';
import styles from './BottomNav.module.css';

interface Props {
  active: MobileTabKey;
  onChange: (tab: MobileTabKey) => void;
}

const TABS: { key: MobileTabKey; label: string; icon: React.ReactNode }[] = [
  { key: 'cabin',     label: '舱室', icon: <AppstoreOutlined /> },
  { key: 'broadcast', label: '广播', icon: <BellOutlined /> },
  { key: 'treasure',  label: '宝箱', icon: <GiftOutlined /> },
  { key: 'profile',   label: '我的', icon: <UserOutlined /> },
];

function BottomNav({ active, onChange }: Props) {
  return (
    <nav className={styles.nav}>
      {TABS.map((tab) => (
        <button
          key={tab.key}
          className={`${styles.tab} ${active === tab.key ? styles.tabActive : ''}`}
          onClick={() => onChange(tab.key)}
        >
          <span className={styles.icon}>{tab.icon}</span>
          <span className={styles.label}>{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default BottomNav;
